﻿(function () {

    'use strict';
    var serviceId = 'repository.oos';
    angular
        .module('app.services')
        .factory(serviceId, oos);

    oos.$inject = ['common', 'repository.abstract', '$http'];

    function oos(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getoosFilters = getoosFilters;
            this.getoosList = getoosList;
            this.getoosListExcel = getoosListExcel;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?legend=oos&codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getoosFilters() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetOOSFilters');
        }

        function getoosList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetOOSList', model);
        }

        function getoosListExcel(model, fileName) {
            common.httpPostFile(config.basePaths.Base_Path_Resources + 'reportList/PrintOOSReport', model, fileName);
        }
    }

})();
